export const advertisementsAddComponent = {
  template: `
        <advertisements-main
          title="add news advertisement"
          advertisement-pages=$ctrl.advertisementPages>
        </advertisements-main>
    `,
  bindings: {
    advertisementPages: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/components/advertisements/advertisements-add/advertisements-add.component.js